import React from 'react';

const Footer = () => {
    return (
        <footer className="py-16 bg-wedding-ivory text-center border-t border-wedding-beige/30">
            <p className="font-serif text-2xl text-wedding-charcoal mb-4">Preksha & Sachu</p>
            <p className="text-xs text-wedding-gray uppercase tracking-[0.2em]">Can't wait to celebrate with you</p>
        </footer>
    );
}; export default Footer;
